/** Výčet typů vstupního pole */
export enum InputType {
    text = "text",
    password = "password",
    number = "number",
    checkbox = "checkbox",
    hidden = "hidden",
}
